import { RangeSlider } from '../RangeSlider/RangeSlider';

type Props = {
    currentTime: number;
    duration: number;
    onSeek: (time: number) => void;
};

export function ProgressBar({ currentTime, duration, onSeek }: Props) {
    return <RangeSlider max={duration} value={currentTime} onChange={onSeek} ariaLabel="Seek" />;
}
